module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: ['modal', _vm.diyClass, {
      'modal-absolute': _vm.positionAbsolute
    }]
  }, [_c('div', {
    staticClass: "modal-dialog diy-modal-position",
    style: ({
      'width': ("" + _vm.width),
      'height': ("" + _vm.height),
      'top': ("" + _vm.top)
    })
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-close"
  }, [_c('i', {
    staticClass: "c-close",
    on: {
      "click": _vm.modalClose
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "modal-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2)])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-shadow"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-backdrop"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b20ba74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/modal/modalSimple.vue
// module id = 838
// module chunks = 1